import { Suspense } from 'react';
import {
  Await,
  matchPath,
  useLoaderData,
  useNavigate,
  useNavigation,
} from 'react-router-dom';
import AdblockChecker from '../../components/AdblockModal';
import Modal from '../../components/Modal';
import Notifs from '../../components/Notifications';
import TickersDisplayBar from '../../components/TickersDisplayBar';
import Header from '../MainPage/Header';
import Loader from '../../components/common/Loader';
import CompetitionBody from './CompetitionBody';
import { competitionLoaderDataType } from '../loaders/competitionLoader';
import { PanelMobile } from '../MainPage/mobile';
import useDevice from '../MainPage/useMobileDetect';

import './styles.scss';

const CompetitionPage = () => {
  const navigation = useNavigation();
  const navigate = useNavigate();
  const { leaderboard } = useLoaderData() as Record<string, any>;
  const { isMobile } = useDevice();

  const isNavigationOnCurrentRoute = matchPath(
    '/competition/:exchange',
    navigation.location?.pathname ?? ''
  );

  const loading = navigation.state === 'loading' && isNavigationOnCurrentRoute;

  return (
    <Suspense
      fallback={
        <div className='centrify'>
          <Loader />
        </div>
      }
    >
      <Await resolve={leaderboard} errorElement={<div>Error Loading</div>}>
        {(leaderboard: competitionLoaderDataType) => {
          if (isMobile) {
            return (
              <PanelMobile title='Competition' onBack={() => navigate(-1)}>
                {loading && (
                  <div className='main_page__backdrop'>
                    <Loader className='main_page__backdrop__loader' />
                  </div>
                )}
                <CompetitionBody leaderboard={leaderboard || []} />
                <Modal />
                <Notifs />
              </PanelMobile>
            );
          }

          return loading ? (
            <div className='main_page__backdrop'>
              <Loader className='main_page__backdrop__loader' />
            </div>
          ) : (
            <div className='main_page' style={{ overflowX: 'hidden' }}>
              <TickersDisplayBar />
              <Header />
              <CompetitionBody leaderboard={leaderboard || []} />
              <Modal />
              <Notifs />
              <AdblockChecker />
            </div>
          );
        }}
      </Await>
    </Suspense>
  );
};

export default CompetitionPage;
